import ScriptFactory from './Factory'

exports.ScriptFactory = ScriptFactory
